var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 45,
        "min-height": 85,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v("SMS Template")]),
          ]
        ),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("sms-message-templates", {
            ref: "smsMessageTemplates",
            attrs: { "enable-save": _vm.enableSave },
            on: { "save-button": _vm.setEnableSave },
          }),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot is-flex is-justify-content-flex-end" },
        [
          _c("div", { staticClass: "buttons" }, [
            !_vm.enableSave
              ? _c(
                  "button",
                  {
                    staticClass: "button is-success tooltip",
                    attrs: { "data-tooltip": "Save template" },
                    on: { click: _vm.add },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "mdi mdi-plus mdi-20px" }),
                    ]),
                    _c("span", [_vm._v("New")]),
                  ]
                )
              : _vm._e(),
            _vm.enableSave
              ? _c(
                  "button",
                  {
                    staticClass: "button is-success tooltip",
                    attrs: { "data-tooltip": "Save template" },
                    on: { click: _vm.save },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "mdi mdi-content-save mdi-20px" }),
                    ]),
                    _c("span", [_vm._v("Save")]),
                  ]
                )
              : _vm._e(),
            _vm.enableSave
              ? _c(
                  "button",
                  {
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Cancel changes" },
                    on: { click: _vm.cancel },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", {
                        staticClass: "mdi mdi-content-save-off mdi-20px",
                      }),
                    ]),
                    _c("span", [_vm._v("Cancel")]),
                  ]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "button tooltip",
                attrs: { "data-tooltip": "Close" },
                on: { click: _vm.close },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-close mdi-20px" }),
                ]),
                _c("span", [_vm._v("Close")]),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }